import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProgressMap from "../../../lms-shared/ProgressMap/ProgressMap";
import classes from './TreeEditTopic.module.css'
import NodeTreeEditTopic from "./NodeTreeEditTopic";
import { useParams } from "react-router-dom";
import { toCApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import LessonViewer from "../../../lms-shared/LessonViewer/LessonViewer";
import studentGlance from '../../../../assests/toc/studentGlance.png'
import { onKeyDown } from "../../../../service";
import { ActivityTypeEnum } from "../../../../models/ActivityTypeEnum";

const TreeEditTopic = ({ isProfession, studyGroup, courseId }) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const uiData = useSelector((state) => state.general.uiData);
    const [topicsData, setTopicsData] = useState()
    const [lesssonViewerId, setLesssonViewerId] = useState(null)
    const [lessonsDataForMap, setLessonsDataForMap] = useState()
    const [showInput, setShowInput] = useState(null)
    const [newTopicName, setNewTopicName] = useState('')
    const [messagesPopup, setMessagesPopup] = useState()
    let { id, applictionName, disciplinId } = useParams()

    if (courseId)
        id = courseId
    const dispatch = useDispatch()
    let LessonsListTemp = [[], [], []]
    // let lastChildIndex = 0;
    let num;
    const componentMounted = useRef(true);

    function getDataApi() {

        let data
        var lessonesListType = uiData[applictionName].lessonesListType;
        let allTopicsList = { [lessonesListType[0]]: [], [lessonesListType[1]]: [], [lessonesListType[2]]: [] }

        if (isProfession) {
            data = {
                courseId: id,
                studyGroupId: null,
                active: null,
                // visible: true,
                ignoreDateRange: false,
                includeAssessments: true
            }
        } else {
            data = {
                courseId: null,
                studyGroupId: id,
                active: null,
                // visible: true,
                ignoreDateRange: false,
                includeAssessments: true
            }
        }
        toCApi.toCFilterRangePost({ toCRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                // see 403 
                if (isProfession) {
                    dispatch(throwApiError({ userMessage: texts.errorNoPermission, error: error, statusCode: response?.statusCode, message: "toCFilterRangePost " + error.message, level: 2, component: "TreeEditTopic", line: 55 }))
                }
                else {
                    dispatch(throwApiError({ userMessage: texts.toCFilterRangePostError, error: error, statusCode: response?.statusCode, message: "toCFilterRangePost " + error.message, level: 2, component: "TreeEditTopic", line: 58 }))
                }
            }
            else {
                if (componentMounted.current && uiData[applictionName].changeDisplayOrder === true) {
                    const contest = resdata[1];
                    resdata[1] = resdata[2];
                    resdata[2] = contest;
                    resortDataTocFromApiForMap(resdata)
                    setTopicsData(resdata)
                }
                else
                    if (componentMounted.current) {
                        resortDataTocFromApiForMap(resdata)
                        const contest = resdata[2];
                        resdata[2] = resdata[1];
                        resdata[1] = contest;
                        setTopicsData(resdata)
                    }
            }
        })
    }
    const resortDataTocFromApiForMap = (data) => {
        var lessonesListType = uiData[applictionName].lessonesListType;
        let allTopicsList = { [lessonesListType[0]]: [], [lessonesListType[1]]: [], [lessonesListType[2]]: [] }
        data && data.map((y, index) => {
            num = 1
            return y.children.map((y2, index2) => createLessonsList(y2, index, index2, data.length, 0, num))
        })

        data.map((z, index) =>
            z.children.map((z1, index1) =>
                allTopicsList[lessonesListType[index]].push({ lessons: LessonsListTemp[index][index1]?.filter(l => l.visible), tag: { id: z1.id, name: z1.name } })))

        setLessonsDataForMap(allTopicsList)

    }
    useEffect(() => {
        if (texts && uiData[applictionName] && (courseId || studyGroup))
            getDataApi()
    }, [texts, id, uiData, courseId, studyGroup])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    function createLessonsList(child, typeLessons, index, lengthParent, lastFiveVisibleLessons) {
        if (child.isLesson == true) {
            if (!LessonsListTemp[typeLessons][index]) {
                LessonsListTemp[typeLessons][index] = [];
            }
            const finalAssessment = child.assessments?.find(a => ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Final);
            if (finalAssessment?.dueDate) {
                child.isLate = new Date(finalAssessment.dueDate) < new Date(finalAssessment.submission?.submittedDate ? finalAssessment.submission.submittedDate : new Date());
            }
            var lessonesListType = uiData[applictionName].lessonesListType;

            child.lessonType = lessonesListType[typeLessons];
            if (!uiData.aiCourses?.list?.includes(id) && !(studyGroup && uiData.aiCourses?.list?.includes(studyGroup[0].courseId)))
                child.indexOnMap = num++;
            else
                child.indexOnMap = lastFiveVisibleLessons + 1;

            LessonsListTemp[typeLessons][index].push(child);

            child.ClientDate = new Date();
        } else {
            const visibleLessons = child.children.filter((c) => c.visible);
            if (visibleLessons.length > 0) {
                const lastVisibleLessons = visibleLessons.slice(-5);
                lastVisibleLessons.forEach((l, indexChild) => {
                    createLessonsList(l, typeLessons, index, child.children.length, lastFiveVisibleLessons + indexChild);
                });
            }
        }
    }

    const updateTopicOrder = (sortedIds, topicId, updatedData) => {
        const toCReSortInput = courseId
            ? {
                courseId: id,
                parentId: topicId,
                sortedIds: sortedIds
            } :
            {
                studyGroupId: id,
                parentId: topicId,
                sortedIds: sortedIds
            };
        toCApi.toCReSortPost({ toCReSortInput: toCReSortInput }, async (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "toCReSortPost " + error.message, level: 1, component: "TreeEditTopic", line: 169 }))
            }
            else {
                // updateding topics data instead of fetch again toc list
                // const updatedTopicsData = updateTopicsData(topicsData, topicId, updatedData);
                // function updateTopicsData(topicsData, topicId, updatedData) {
                //     return topicsData.map((topic) => {
                //         if (topic.id === topicId) {
                //             return {
                //                 ...topic,
                //                 children: updatedData,
                //             };
                //         } else if (topic.children) {
                //             const updatedChildren = updateTopicsData(topic.children, topicId, updatedData);
                //             if (updatedChildren !== topic.children) {
                //                 return {
                //                     ...topic,
                //                     children: updatedChildren,
                //                 };
                //             }
                //         }
                //         return topic;
                //     });
                // }
                // resortDataTocFromApiForMap(updatedTopicsData)
                getDataApi()
            }
        })
    }



    const HandleChangeName = (e) => {
        setNewTopicName(e.target.value)
    }

    const HandleOnBlur = (index) => {
        setShowInput(null)
        // api call toc/add
        if (newTopicName) {
            const data = {
                courseId: id,
                parentId: topicsData[index].id,
                name: newTopicName,
                active: true,
                visible: true,
                prevId: topicsData && topicsData[index]?.children?.length > 0 ? topicsData[index].children[topicsData[index].children.length - 1].id : null
            }
            toCApi.toCAddPost({ toCAddInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "toCAddPost " + error.message, level: 1, component: "TreeEditTopic", line: 203 }))
                }
                else {
                    if (componentMounted.current) {
                        getDataApi()
                    }
                }
            })
        }
    }

    const handleShowLessonViewer = (id) => {
        setLesssonViewerId(id)
    }
    const closeLessonViewrPopup = () => {
        setLesssonViewerId(null)
    }

    const getTopicTitle = index => {
        switch (index) {
            case 0: return texts.regularTopicTitle;
            case 1: return isProfession ? texts.contestTitle : texts.contest;
            case 2: return texts.enrichmenTitle;
            default: return '';
        }
    }

    return (
        <div className={`${classes.treeEditTopicContainer}  ${classes[direction]}`}>
            {/* <p className={classes.Title}>{texts.editStudySubjectsAndAddLessons}</p> */}

            {uiData && <div className={classes.treeEditTopic}>
                <div className={classes.DragDropContainerOverflow}>
                    <div className={classes.DragDropContainer}>
                        {topicsData && uiData && topicsData.map((typeTopic, index) => (
                            <React.Fragment key={index}>
                                {typeTopic ?
                                    <React.Fragment key={index}>
                                        <h1 className={index === 0 ? classes.RegularTitle : classes.EnrichmenTitle}>{getTopicTitle(index)}</h1>
                                        {typeTopic.children.length ? <>
                                            <div className={classes.AllTopics}>
                                                {typeTopic.children.map((item, index1) => (
                                                    <NodeTreeEditTopic topicId={item.id} updateTopicOrder={updateTopicOrder} isProfession={isProfession} addNewLesson={index === 1 && !isProfession ? false : true} key={index1} topic={item} studyGroupId={id} courseName={studyGroup && studyGroup[0] && studyGroup[0].name && studyGroup[0].name} refreshTopicList={getDataApi} isDraggable={true} />
                                                ))
                                                }
                                            </div>
                                        </> : <div>{texts.noDataToView}</div>}
                                        <div className={classes.AddTopicContainer}>
                                            {isProfession && (index !== 2 || topicsData[2]?.children?.length < 2) &&
                                                <div className={classes.AddTopic} onClick={() => setShowInput(index)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowInput(index))}>
                                                    <div className={classes.Circle}>+</div>
                                                    <p className={classes.NewTopicText}>{texts.addTopic}</p>
                                                </div>
                                            }
                                            {showInput === index &&
                                                <div className={classes.NewTopic}>
                                                    <input
                                                        type='text'
                                                        name="NewTopic"
                                                        // placeholder={texts.writeSomething}
                                                        className={`${classes.Input} ${classes.NewTopicInput}`}
                                                        onChange={HandleChangeName}
                                                        onBlur={() => HandleOnBlur(index)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </React.Fragment> : ''}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                <div className={classes.ProgressMapContainer}>
                    <div className={classes.explanation}>
                        <img className={classes.Img} src={studentGlance} alt="studentGlance" />
                        <h2 className={classes.MapTitle}>{texts.mapExplanation}</h2>
                    </div>
                    {lessonsDataForMap && (disciplinId || id) && <ProgressMap aiCourse={uiData.aiCourses?.list?.includes(id) || (studyGroup && uiData.aiCourses?.list?.includes(studyGroup[0].courseId))} handleShowLessonViewer={handleShowLessonViewer} topicsList={lessonsDataForMap} studyGroupId={id} markUserPlace={false} setMessagePopup={setMessagesPopup} />}
                </div>
                {
                    lesssonViewerId && <div className={classes.LessonViewerWarrper}>
                        <LessonViewer handleCloseCallBack={closeLessonViewrPopup} teacherMode={true} lessonId={lesssonViewerId} studyGroupId={id} showClosePopup={false}></LessonViewer>
                    </div>
                }
            </div >}
            {messagesPopup}
        </div >
    )
}

export default TreeEditTopic;


